import React from "react";
import { useLocation } from "react-router-dom";
import { useHotel } from "../contexts/HotelContext";
import Footer from "./Footer";

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const { user, getTenantDisplayInfo } = useHotel();
  const location = useLocation();

  // Check if this is a public offer page (hide header for these pages)
  const isPublicOfferPage = location.pathname.startsWith("/offers/public/");

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Conditionally render header - hide for public offer pages */}
      {!isPublicOfferPage && (
        <header className="bg-white shadow-sm border-b">
          <div className="container mx-auto px-4 py-4">
            <div className="flex justify-between items-center">
              <a
                href="/"
                className="text-xl font-bold text-primary-600 hover:text-primary-700"
              >
                {getTenantDisplayInfo().title}
              </a>
              <div>
                {user ? (
                  <a
                    href="/"
                    className="bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700 transition-colors"
                  >
                    Dashboard
                  </a>
                ) : (
                  <a
                    href="/login"
                    className="bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700 transition-colors"
                  >
                    Zaloguj się
                  </a>
                )}
              </div>
            </div>
          </div>
        </header>
      )}

      {/* id + tabIndex: programmatic focus target after the legal consent
          modal closes (SoftModal must never leave focus on <body>). */}
      <main
        id="main-content"
        tabIndex={-1}
        className={`container mx-auto px-4 ${!isPublicOfferPage ? "py-8" : ""} focus:outline-none`}
      >
        {children}
      </main>
      <div className="container mx-auto px-4 print:hidden">
        <Footer />
      </div>
    </div>
  );
};

export default PublicLayout;
